/**
 * Laravel will convert objects into arrays when there is no data
 * this just screws up everything randomly, we fix this here
 * [] !== {}
 */
export default {
	methods: {
		/**
		 * Checks if the data is an array or object
		 * Checks if object has any value at all
		 * Checks if array or object has items in it
		 *
		 * @param obj
		 * @param objDefault
		 * @returns {boolean|*}
		 */
		exists (obj, objDefault = false) {
			if (!obj) {
				return false
			}

			if (Array.isArray(obj)) {
				if (obj.length <= 0) {
					return objDefault
				}

				return obj.length > 0
			}

			if (Object.keys(obj).length <= 0) {
				return objDefault
			}

			return Object.keys(obj).length > 0
		},

		/**
		 * Counts items in array or object
		 * If object contains "data" we will assume that is the collection
		 *
		 * @param obj
		 * @returns {number|*}
		 */
		length (obj) {
			if (!obj) {
				return 0
			}

			if (obj.hasOwnProperty('data')) {
				obj = obj.data
			}

			if (Array.isArray(obj)) {
				return obj.length
			}

			return Object.keys(obj).length
		},

		/**
		 * Converts an objet key into human readable label
		 *
		 * @param word
		 * @returns {string}
		 */
		keyToHuman (word) {
			let string = ''

			const words = word.split('_')

			for (const wordsKey in words) {
				if (!words.hasOwnProperty(wordsKey)) continue
				const word = words[wordsKey]
				const lower = word.toLowerCase()

				if (wordsKey !== '0') {
					string = string + ' '
				}

				string = string + word.charAt(0).toUpperCase() + lower.slice(1)
			}


			return string
		},
		inertiaLink (routeName, params) {
			this.$inertia.visit(this.route(routeName, params))
		}
	}
}
